import { combineReducers } from '@reduxjs/toolkit';
import { defaultProductSettingsReducer } from './reducers/default-product-settings-reducer';
import type { IProductSettingsState } from './interfaces';

export default combineReducers<IProductSettingsState>({
  defaultProductSettingsReducer,
});
